<template>
    <veui-uploader
        class="muse-uploader"
        v-bind="$props"
        @failure="failure"
        :compat="compat"
        v-on="$listeners">
        <template slot="desc"><slot name="desc"></slot></template>
        <template slot="button-label"><slot name="button-label"></slot></template>
        <template slot="failure-label" v-if="failureText != null"><span class="muse-uploader-failure-label">{{failureText}}</span></template>
    </veui-uploader>
</template>

<script>
// 这个文件是新建，和以前一个废弃版本且使用了vuex的Uploader同名，以前的无用，被删除了。

import {Uploader} from 'veui';
import {extend, get} from 'lodash';

const {
    name,
    requestMode,
    iframeMode,
    callbackNamespace,
    convertResponse
} = Uploader.props;

const defaultConvertResponse = (data = {}) => {
    // 有些上传的地方依赖了字段url，迁移过来的时候要注意
    let success = data.code === 0 || ('' + data.success === 'true');
    let reason = null;
    if (!success && data.message) {
        reason = data.message.ERROR || data.message;
    }
    extend(data, {
        status: success ? 'success' : 'failure',
        src: success ? (get(data, 'result.url') || get(data, 'result.src')) : '',
        reason
    });
    data.result = null;
    return data;
};

export default {
    name: 'muse-uploader',
    components: {
        'veui-uploader': Uploader
    },
    data() {
        return {
            failureText: null
        };
    },
    props: {
        ...Uploader.props,
        name: {
            ...name,
            default: 'filedata'
        },
        requestMode: {
            ...requestMode,
            default: 'iframe'
        },
        iframeMode: {
            ...iframeMode,
            default: 'callback'
        },
        callbackNamespace: {
            ...callbackNamespace,
            default: 'veuiUploadResult'
        },
        convertResponse: {
            ...convertResponse,
            default: defaultConvertResponse
        },
        compat: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        failure(file) {
            this.failureText = file.reason;
        }
    },
    model: Uploader.model
};
</script>

<style lang="less">
// @import "../css/lib.less";

// .muse-uploader {
//     .muse-uploader-failure-label {
//         width: 4em;
//         display: inline-block;
//         .ellipsis();
//     }
// }
</style>
